export default __webpack_public_path__ + "static/media/icon-value-Economies.ac10e2c7.svg";